<template>
  <div class="diagnosis-form-wrapper">
    <div class="title">
      <div style="display: flex;align-items: center;">
        <i class="title-icon iconfont icon-iconset0123"></i>
        <span class="title-label">相关信息</span>
      </div>
    </div>
    <div class="content">
      <el-form
        :model="operationDiagnoses"
        size="mini"
        status-icon
        :rules="checkRules"
        style="width:95%"
        label-width="80px"
        label-position="left"
      >
        <el-form-item label="治疗编号**">
          <div style="display: flex;justify-content: space-between;align-items: center;">
            <el-input
              ref="idInHospital"
              v-model="commonData.treat_no"
              style="flex: 1;"
              :disabled="commonData.treat_no !== ''"
              :readonly="true || fromDetailDiagnose"
              placeholder="治疗编号"
            ></el-input>
            <!--<div class="auto-create-btn" @click="getIdInHospital" :class="{disabled: commonData.treat_no}">自动生成</div>-->
          </div>
        </el-form-item>
        <el-form-item label="次数">
          <div style="display: flex;justify-content: space-between;align-items: center;">
            <div
              class="number-of-treatment"
              :disabled="true"
            >{{[commonData.thisNum, commonData.totalNum] | formatNumberOfTreatment}}</div>
            <div class="auto-create-btn" @click="modifyNumberOfTreatment" v-if="!modifyNumberOfTreatmentBtnDisabled">
              编辑</div>
            <div class="auto-create-btn" style="cursor: default" v-if="modifyNumberOfTreatmentBtnDisabled">
              编辑</div>
          </div>
        </el-form-item>
        <el-form-item label="门诊诊断" prop="initial_conclusion">
          <el-autocomplete
            style="width: 100%;"
            class="popInput"
            v-model="operationDiagnoses.diagnosis_template"
            :fetch-suggestions="queryDisease"
            placeholder="诊断结果"
            :trigger-on-focus="false"
            @select="chooseDisease"
            @blur="diagnosisTemplateBlur"
            size="small"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="主诉">
          <el-input
            v-model="operationDiagnoses.main_suit"
            style="width: 100%;"
            placeholder="不得超过512个字"
            :readonly="fromDetailDiagnose"
            type="textarea"
            @blur="addRelevantInfomation"
            :maxlength="textAreaMaxLen"
          ></el-input>
        </el-form-item>
        <el-form-item label="既往史">
          <el-input
            v-model="operationDiagnoses.past_history"
            style="width: 100%;"
            placeholder="不得超过512个字"
            :readonly="fromDetailDiagnose"
            type="textarea"
            @blur="addRelevantInfomation"
            :maxlength="textAreaMaxLen"
          ></el-input>
        </el-form-item>
        <el-form-item label="操作医生">
          <el-autocomplete
            v-model="operationDiagnoses.operation_doctor"
            style="width: 100%;"
            :readonly="fromDetailDiagnose"
            placeholder="操作医生"
            :fetch-suggestions="queryOperationDoctorCache"
            @select="selectOperationDoctorCache"
            @blur="addRelevantInfomation"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="首诊医生">
          <el-autocomplete
            v-model="operationDiagnoses.register_doctor"
            style="width: 100%;"
            :readonly="fromDetailDiagnose"
            placeholder="首诊医生"
            :fetch-suggestions="queryRegisterDoctorCache"
            @select="selectRegisterDoctorCache"
            @blur="addRelevantInfomation"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="费用">
          <div style="display: flex;justify-content: space-between;align-items: center;">
            <el-input
              v-model="operationDiagnoses.fee"
              style="flex: 1;margin-right: 2%;"
              :readonly="fromDetailDiagnose"
              placeholder="费用"
              :disabled="accountPayDisabled"
              @blur="addRelevantInfomation"
            ></el-input>
            <div class="auto-create-btn" @click="accountPay" :class="{disabled: accountPayDisabled}">缴费</div>
          </div>
        </el-form-item>
        <el-form-item label="账户余额">
          <div style="display: flex;justify-content: space-between;align-items: center;">
            <el-input
              v-model="commonData.balance"
              style="flex: 1;margin-right: 2%;"
              :readonly="fromDetailDiagnose"
              placeholder=""
              :disabled="true"
            ></el-input>
            <div class="auto-create-btn" @click="showAccountRecharge">充值</div>
          </div>
        </el-form-item>



        <el-form-item label="备注">
          <!-- <el-alert type="info" show-icon :closable="false">
            <p>"Full Name" label is automatically attached to the input:</p>
          </el-alert> -->
            <!-- <el-popover
              placement="top-start"
              title="帮助"
              width="200"
              trigger="hover"
              content="此处输入的备注信息，可以在【高级搜索】-【美容/治疗】-【就诊记录】中进行检索"
            >
              <i slot="reference" class="iconfont icon-bangzhu popTips" ></i>
            </el-popover> -->

          <el-input
            v-model="operationDiagnoses.remarks"
            style="width: 100%;"
            :readonly="fromDetailDiagnose"
            placeholder="不得超过512个字; 可在【高级搜索->美容/治疗->就诊记录】中检索"
            type="textarea"
            @blur="addRelevantInfomation"
          ></el-input>
          

        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      title="充值"
      :visible.sync="isShowRechargeDialog"
      width="30%"
    >
      <div class="dialog-box">
        <div class="label">充值金额</div>
        <div class="input-box">
          <el-input
            ref="rechargeAmount"
            v-model="rechargeAmount"
            style="width: 100%;"
            placeholder="请输入充值金额"
            @keydown.native.enter="accountRecharge"
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="isShowRechargeDialog = false">取 消</el-button>
    <el-button type="primary" @click="accountRecharge">确 定</el-button>
  </span>
    </el-dialog>
    <CommonNumberOfTreatment ref="CommonNumberOfTreatment"/>
  </div>
</template>

<script>
  import knowledgeDicTemplate from "../utils/knowledgeDicTemplate.js";
  import CommonNumberOfTreatment from './CommonNumberOfTreatment.vue';
  import gql from 'graphql-tag';
  
  export default {
    
    components: {
      CommonNumberOfTreatment,
    },
    
    provide() {
      return {
        diagnosisFormData: this.diagnosisFormData,
        addRelevantInfomation: this.addRelevantInfomation,
      };
    },
    
    inject: {
      commonData: ['commonData'],
    },
    
    data() {
      return {
        operationDiagnoses: {
          diagnosis_template: "",
          main_suit: "",
          past_history: "",
          operation_doctor: "",
          register_doctor: "",
          fee: "",
          remarks: "",
        },
        checkRules: {},
        fromDetailDiagnose: false,
        diagnosis_template_id: '',
        isChangeRelevantInfo: false,
        textAreaMaxLen: 512,
        // 是否显示充值弹框
        isShowRechargeDialog: false,
        // 充值金额
        rechargeAmount: '',
        accountPayDisabled: false,
        diagnosisFormData: {
          // 是否显示次数弹框
          isShowNumberOfTreatmentDialog: false,
        },
        // 编辑次数按钮禁用
        modifyNumberOfTreatmentBtnDisabled: false,
      };
    },
    
    watch: {
      isShowRechargeDialog(val) {
        if (val) {
          // 输入框聚焦
          this.$nextTick(() => {
            this.$refs.rechargeAmount.focus();
          });
        }
      },
    },
  
    mixins: [knowledgeDicTemplate],
    
    methods: {
      async chooseDisease(item) {
        // this.diagnosis_template_id = item.id;
        // this.$store.commit("setoperationPrintDiagnoses", item.value);
        this.isChangeRelevantInfo = true;
        // this.addRelevantInfomation();
      },
      async addRelevantInfomation() {
        // if (this.isChangeRelevantInfo) {
          let bool = false;
          if (this.commonData.patientId > -1) {
            if (this.commonData.treat_no) {
              if (this.commonData.relevantInfoId > -1) {
                bool = await this.setRelevantInfomation();
              } else {
                bool = await this.mutateRelevantInfomation();
              }
            } else {
              this.$message.error("请填写诊断**内容");
            }
          } else {
            this.$message.error("请填写患者信息");
          }
          this.cacheDoctorName();
          return bool;
        // }
      },
      // 创建相关信息
      async mutateRelevantInfomation() {
        const variables = {
          patient_id: this.commonData.patientId,
          treat_no: this.commonData.treat_no,
          diagnosis: this.operationDiagnoses.diagnosis_template,
          main_suit: this.operationDiagnoses.main_suit,
          past_history: this.operationDiagnoses.past_history,
          operate_doctor: this.operationDiagnoses.operation_doctor,
          register_doctor: this.operationDiagnoses.register_doctor,
          fee: this.operationDiagnoses.fee * 100,
          remarks: this.operationDiagnoses.remarks,
          parent_id: this.commonData.parent_id,
          total_times: this.commonData.totalNum,
          current_times: this.commonData.thisNum,
        };
        try {
          const res = await this.$apollo.mutate({
            mutation: gql`mutation(
              $patient_id: Int!
              $treat_no: String!
              $diagnosis: String!
              $main_suit: String!
              $past_history: String!
              $operate_doctor: String!
              $register_doctor: String!
              $fee: Float!
              $remarks: String!
              $parent_id: String!
              $total_times: Int!
              $current_times: Int!
            ){
              addCosmetologyReleInfo(
                patient_id: $patient_id
                treat_no: $treat_no
                diagnosis: $diagnosis
                main_suit: $main_suit
                past_history: $past_history
                operate_doctor: $operate_doctor
                register_doctor: $register_doctor
                fee: $fee
                remarks: $remarks
                parent_id: $parent_id
                total_times: $total_times
                current_times: $current_times
              ){
                id
              }
            }`,
            variables,
          });
          this.commonData.relevantInfoId = res.data.addCosmetologyReleInfo.id;
          this.$message({
            type: "success",
            message: "添加成功",
          });
          // 默认新建一个参数编号
          this.$root.$emit('add-par-num', '1');
          this.$root.$emit('getCosmetologyTreatDetailsByPatient');
          return true;
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
          return false;
        }
      },
      // 修改相关信息
      async setRelevantInfomation() {
        const variables = {
          id: this.commonData.relevantInfoId,
          treat_no: this.commonData.treat_no,
          diagnosis: this.operationDiagnoses.diagnosis_template,
          main_suit: this.operationDiagnoses.main_suit,
          past_history: this.operationDiagnoses.past_history,
          operate_doctor: this.operationDiagnoses.operation_doctor,
          register_doctor: this.operationDiagnoses.register_doctor,
          fee: this.operationDiagnoses.fee * 100,
          remarks: this.operationDiagnoses.remarks,
          parent_id: this.commonData.parent_id,
          total_times: this.commonData.totalNum,
          current_times: this.commonData.thisNum,
        };
        try {
          const res = await this.$apollo.mutate({
            mutation: gql`mutation(
              $id: Int!
              $patient_id: Int
              $treat_no: String
              $diagnosis: String
              $main_suit: String
              $past_history: String
              $operate_doctor: String
              $register_doctor: String
              $fee: Float!
              $remarks: String!
              $parent_id: String
              $total_times: Int
              $current_times: Int
            ){
              modifyCosmetologyReleInfo(
                id: $id
                patient_id: $patient_id
                treat_no: $treat_no
                diagnosis: $diagnosis
                main_suit: $main_suit
                past_history: $past_history
                operate_doctor: $operate_doctor
                register_doctor: $register_doctor
                fee: $fee
                remarks: $remarks
                parent_id: $parent_id
                total_times: $total_times
                current_times: $current_times
              )
            }`,
            variables,
          });
          return true;
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
          return false;
        }
      },
      // 自动生成id
      async getIdInHospital() {
        if (!(this.commonData.patientId > -1 && this.commonData.patientIdInHospital)) {
          this.$message.error('请添加患者信息');
          return;
        }
        if (this.commonData.treat_no) {
          return;
        }
        try {
          const res = await this.$apollo.mutate({
            mutation: gql`mutation(
              $patient_id: Int!
              $patient_id_in_hospital: String!
            ){
              gentTreatNo(
                patient_id: $patient_id
                patient_id_in_hospital: $patient_id_in_hospital
              )
            }`,
            variables: {
              patient_id: this.commonData.patientId,
              patient_id_in_hospital: this.commonData.patientIdInHospital,
            },
          });
          this.commonData.treat_no = res.data.gentTreatNo;
          await this.addRelevantInfomation();
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
      // 缴费
      async accountPay() {
        if (this.operationDiagnoses.fee) {
          if (this.commonData.relevantInfoId === -1) {
            this.$message.error('请添加相关信息');
            return;
          }
          if (this.accountPayDisabled) {
            return;
          }
          try {
            const res = await this.$apollo.mutate({
              mutation: gql`mutation(
                $patient_id: Int!
                $pay_num: Float!
              ){
                accountPay(
                  patient_id: $patient_id
                  pay_num: $pay_num
                )
              }`,
              variables: {
                patient_id: this.commonData.patientId,
                pay_num: this.operationDiagnoses.fee * 100,
              },
            });
            if (res.data.accountPay !== '余额不足') {
              this.$message({
                type: "success",
                message: "已缴费",
              });
              this.commonData.balance = String(res.data.accountPay / 100);
              this.accountPayDisabled = true;
            } else {
              this.$message.error('账户余额不足')
            }
          } catch (error) {
            this.$message.error(error.message.split(":")[1]);
          }
        } else {
          this.$message.error('请输入金额')
        }
      },
      // 显示充值弹框
      showAccountRecharge() {
        if (this.commonData.patientId === -1) {
          this.$message.error('请添加患者信息');
          return;
        }
        this.isShowRechargeDialog = true;
      },
      // 充值
      async accountRecharge() {
        if (this.commonData.patientId > -1 && this.rechargeAmount) {
          try {
            const res =await this.$apollo.mutate({
              mutation: gql`mutation(
                $patient_id: Int!
                $recharge_num: Float!
              ){
                accountRecharge(
                  patient_id: $patient_id
                  recharge_num: $recharge_num
                )
              }`,
              variables: {
                patient_id: this.commonData.patientId,
                recharge_num: this.rechargeAmount * 100,
              },
            });
            this.commonData.balance = String(res.data.accountRecharge / 100);
            this.isShowRechargeDialog = false;
            this.rechargeAmount = '';
          } catch (error) {
            this.$message.error(error.message.split(":")[1]);
          }
        }
      },
      diagnosisTemplateBlur() {
        setTimeout(() => {
          // if (this.operationDiagnoses.diagnosis_template) {
          //   if (!(this.isChangeRelevantInfo && this.diagnosis_template_id)) {
          //     this.$message.error('请选择诊断结果');
          //   }
          // }
          const id = this.queryTemplatesByName(this.operationDiagnoses.diagnosis_template);
          if (id) {
            this.diagnosis_template_id = id;
          } else {
            this.diagnosis_template_id = '';
          }
          this.addRelevantInfomation();
        }, 300);
      },
      // 编辑治疗次数
      modifyNumberOfTreatment() {
        if (this.commonData.patientId === -1) {
          this.$message.error('请添加患者信息');
          return;
        }
        this.diagnosisFormData.isShowNumberOfTreatmentDialog = true;
      },
      // 显示相关信息
      async showCosmetologyInfo(patient_id, treat_no) {
        try {
          const res = await this.$apollo.query({
            query: gql`query(
              $patient_id: Int!
              $treat_no: String!
            ){
              getCosmetologyReleInfo(
                patient_id: $patient_id
                treat_no: $treat_no
              ){
                id
                treat_no
                current_times
                total_times
                parent_id
                diagnosis
                main_suit
                past_history
                operate_doctor
                register_doctor
                fee
                remarks
              }
            }`,
            fetchPolicy: "no-cache",
            variables: {
              patient_id,
              treat_no,
            }
          });
          const resData = res.data.getCosmetologyReleInfo;
          this.commonData.relevantInfoId = resData.id;
          this.commonData.treat_no = resData.treat_no;
          this.commonData.totalNum = resData.total_times;
          this.commonData.parent_id = resData.parent_id;
          this.operationDiagnoses.diagnosis_template = this.formatConclusion(resData.diagnosis);
          this.operationDiagnoses.main_suit = resData.main_suit;
          this.operationDiagnoses.past_history = resData.past_history;
          this.operationDiagnoses.operation_doctor = resData.operate_doctor;
          this.operationDiagnoses.register_doctor = resData.register_doctor;
          this.operationDiagnoses.fee = String(resData.fee / 100);
          this.operationDiagnoses.remarks = resData.remarks;
          return resData;
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
      // 缓存操作医生和登记医生输入的内容
      cacheDoctorName() {
        if (this.operationDiagnoses.operation_doctor || this.operationDiagnoses.register_doctor) {
          if (window.localStorage.getItem('cosmetologyDoctorCache')) {
            const doctorCache = JSON.parse(window.localStorage.getItem('cosmetologyDoctorCache'));
            // 缓存 operation_doctor
            if (this.operationDiagnoses.operation_doctor) {
              if (doctorCache.operation_doctor) {
                const findIndex = doctorCache.operation_doctor.findIndex((item) => item === this.operationDiagnoses.operation_doctor);
                if (findIndex === -1) {
                  doctorCache.operation_doctor.unshift(this.operationDiagnoses.operation_doctor)
                }
              } else {
                doctorCache.operation_doctor = [this.operationDiagnoses.operation_doctor];
              }
            }
            // 缓存 register_doctor
            if (this.operationDiagnoses.register_doctor) {
              if (doctorCache.register_doctor) {
                const findIndex = doctorCache.register_doctor.findIndex((item) => item === this.operationDiagnoses.register_doctor);
                if (findIndex === -1) {
                  doctorCache.register_doctor.unshift(this.operationDiagnoses.register_doctor)
                }
              } else {
                doctorCache.register_doctor = [this.operationDiagnoses.register_doctor];
              }
            }
            window.localStorage.setItem('cosmetologyDoctorCache', JSON.stringify(doctorCache));
          } else {
            const doctorCache = {};
            if (this.operationDiagnoses.operation_doctor) {
              doctorCache.operation_doctor = [this.operationDiagnoses.operation_doctor];
            }
            if (this.operationDiagnoses.register_doctor) {
              doctorCache.register_doctor = [this.operationDiagnoses.register_doctor];
            }
            window.localStorage.setItem('cosmetologyDoctorCache', JSON.stringify(doctorCache));
          }
        }
      },
      // 查找操作医生缓存
      queryOperationDoctorCache(queryString, cb) {
        if (window.localStorage.getItem('cosmetologyDoctorCache')) {
          const data = JSON.parse(window.localStorage.getItem('cosmetologyDoctorCache'));
          if (data.operation_doctor) {
            cb(data.operation_doctor.slice(0, 5).map((item) => ({value: item})));
          } else {
            cb([]);
          }
        } else {
          cb([]);
        }
      },
      selectOperationDoctorCache() {
        this.addRelevantInfomation();
      },
      // 查找登记医生缓存
      queryRegisterDoctorCache(queryString, cb) {
        if (window.localStorage.getItem('cosmetologyDoctorCache')) {
          const data = JSON.parse(window.localStorage.getItem('cosmetologyDoctorCache'));
          if (data.register_doctor) {
            cb(data.register_doctor.slice(0, 5).map((item) => ({value: item})));
          } else {
            cb([]);
          }
        } else {
          cb([]);
        }
      },
      selectRegisterDoctorCache() {
        this.addRelevantInfomation();
      },
    },
    
    async mounted() {
      // console.log("In CommonDiagnosisForm,mounted,this.$route.query:",this.$route.query);
      // console.log("this.$store.state.cosmetologyData.status:",this.$store.state.cosmetologyData.status);

      this.$root.$on('automaticGetIdInHospital', () => {
        this.getIdInHospital();
      });
      await this.getKnowledgeDic();
      await this.queryMyTemplate();
      // 如果是继续治疗就填上相关信息
      if (this.$store.state.continueTreatData.status) {
        const left_times = this.$store.state.continueTreatData.left_times;
        const total_times = this.$store.state.continueTreatData.total_times;
        const parent_id = this.$store.state.continueTreatData.parent_id;
        const patient_id = this.$store.state.continueTreatData.patient_id;
        const treat_no = this.$store.state.continueTreatData.treat_no;
        let cosmetologyInfoRes = await this.showCosmetologyInfo(patient_id, treat_no);
        this.$store.commit('addContinueTreatStatusCount');
      
        // 自动生成治疗编号
        const timer = setInterval(async () => {
          if (this.commonData.patientId > -1 && this.commonData.patientIdInHospital) {
            clearInterval(timer);
            await this.getIdInHospital();
            /*await this.showCosmetologyInfo(patient_id, treat_no);*/
            this.commonData.totalNum = total_times;
            this.commonData.thisNum = total_times - left_times + 1;
            this.commonData.parent_id = parent_id;
            this.addRelevantInfomation();
            
            // 选中套餐
            this.$refs.CommonNumberOfTreatment.selectCurrentRow(parent_id, total_times, this.commonData.thisNum);
          }
        }, 200);
        
      }
      // 如果是点击编辑跳转过来
      if (this.$store.state.modifyCosmetologyData.status) {
        const patient_id = this.$store.state.modifyCosmetologyData.patient_id;
        const treat_no = this.$store.state.modifyCosmetologyData.treat_no;
        const current_times = this.$store.state.modifyCosmetologyData.current_times;
        const total_times = this.$store.state.modifyCosmetologyData.total_times;
        const parent_id = this.$store.state.modifyCosmetologyData.parent_id;
        this.$store.commit('addModifyCosmetologyStatusCount');
        let cosmetologyInfoRes = await this.showCosmetologyInfo(patient_id, treat_no);
        this.commonData.thisNum = cosmetologyInfoRes.current_times;
        this.$root.$emit('getCosmetologyTreatDetailsByPatient');
        // 禁止编辑套餐
        // this.modifyNumberOfTreatmentBtnDisabled = true;
        // 选中套餐
        this.$refs.CommonNumberOfTreatment.selectCurrentRowForModify(parent_id, total_times, current_times);
      }
      // 如果是患者列表条转过来
      if (this.$store.state.cosmetologyData.status) {
        this.$store.commit('addCosmetologyStatusCount');
        // 自动生成治疗编号
        const timer = setInterval(async () => {
          if (this.commonData.patientId > -1 && this.commonData.patientIdInHospital) {
            clearInterval(timer);
            await this.getIdInHospital();
          }
        }, 200);
      }

      // console.log("In CommonDiagnosisForm:");
      // console.log("this.$store.state.continueTreatData.statusCount:",this.$store.state.continueTreatData.statusCount);
      // console.log("this.$store.state.modifyCosmetologyData.statusCount:",this.$store.state.modifyCosmetologyData.statusCount);
      // console.log("this.$store.state.cosmetologyData.statusCount:",this.$store.state.cosmetologyData.statusCount);
    },
    
    beforeDestroy() {
      this.$root.$off('automaticGetIdInHospital');
    },
    
    filters: {
      formatNumberOfTreatment(arr) {
        return `第${arr[0]}次/共${arr[1]}次`;
      },
    }
  
  }
</script>

<style>
/* 既往史/备注等文字区域的默认高度 */
.diagnosis-form-wrapper textarea{
    height: 64px;
  }
</style>
<style lang="less" scoped>

// .el-input__textarea {
//   min-height: 80px; /* 设置默认最小高度 */
// }
.el-form-item {
  margin-bottom: 10px;
}
.auto-create-btn{
  width: 66px;
  height:28px;
  color: #fff;
  box-sizing: border-box;
  background-color: rgb(77,162,190);
  font-size: 14px;
  border-radius: 5px;
  box-sizing: border-box;
  border: 1px solid rgb(220,223,230);
  user-select: none;
  cursor: pointer;
  text-align: center;
}
.auto-create-btn.disabled{
  cursor: default;
}

.diagnosis-form-wrapper{
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .title {
    display: flex;
    justify-content: space-between;
    width: calc(100% - 30px);
    color: #48a3c2;
    font-size: 16px;
    border-bottom: 2px solid #48a3c2;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-bottom: 10px;
    overflow: hidden;
    height: 25px;
    text-align: left;
    align-items: center;
    .title-icon{
      font-size:24px;
      margin-right:10px;
    }
    .title-label{
      white-space: nowrap;
      font-size: 18px;
    }
  }
  .content{
    flex: 1;
    overflow-y: auto;
    padding-right: 7%;
    text-align: right;
    height: 50%;
  }
  .dialog-box{
    display: flex;
    align-items: center;
    .label{
      width: 80px;
      font-weight: bold;
    }
    .input-box{
      flex: 1;
    }
  }
  .number-of-treatment{
    flex: 1;
    margin-right: 2%;
    height: 28px;
    color: rgb(96,98,102);
    box-sizing: border-box;
    background-color: rgb(245,247,250);
    border: 1px solid rgb(228,231,237);
    text-align: left;
    text-indent: 15px;
    user-select: none;
  }
}
</style>
